import React, { useEffect, useState, Fragment } from 'react';
import { withRouter, useHistory } from 'react-router-dom';
import Wrapper from '../../components/Wrapper/Wrapper';
import { tripTableHeight, tableHeightWithSparkline } from "../../../styleVariables";
import { DataGrid } from '@material-ui/data-grid';
import { connect } from "react-redux";
import { logoutUser } from "../../../store/actions/authActionCreators";
import MUIDataTable from "mui-datatables";
import {
    getVehicleLedgerData
} from "../../../store/actions/vehicleActionCreator";
import * as logger from "../../../logger";
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import InputAdornment from '@material-ui/core/InputAdornment';
import SearchIcon from '@material-ui/icons/Search';
import { numberFormat } from '../../../utils/utils'
import Button from '@material-ui/core/Button';
import AddIcon from '@material-ui/icons/Add';
import Grid from '@material-ui/core/Grid';
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';
import useStyles from '../css/listing';
import ArrowRightAltIcon from '@material-ui/icons/ArrowRightAlt';
import FiberManualRecordIcon from "@material-ui/icons/FiberManualRecord";
import TopCard from '../../components/TopCard/TopCard';
import { trackDwebEvent } from '../../analytics';
import { Waypoint } from "react-waypoint";
import { debounce } from 'lodash';
import { defaultPageNo, defaultPageSize, defaultDebounceMs } from '../../../paginationVariables';
const Vehicles = ({ user, vehicle, dispatchGetVehicleLedgerAction }) => {
    const classes = useStyles();
    let history = useHistory();
    const [vehicleLedgerData, setVehicleLedgerData] = useState([]);
    const [addVehicleModalOpen, setVehicleModalOpen] = useState(false);
    const [searchText, setSearchText] = useState("");
    const [currentPageNo, setCurrentPageNo] = useState(defaultPageNo);
    const [currentPageSize, setCurrentPageSize] = useState(defaultPageSize);
    const [loadingText, setLoadingText] = useState("Sorry, no Trucks found");


    const vehicleLedgerRequestData = {
        fleetOwnerId: user.userInfo.entityId,
        ownershipType: ["SELF", "HIRED"],
        vehicleStatus: ["AVAILABLE", "ONTRIP"],
        pageNo: defaultPageNo,
        pageSize: defaultPageSize,
    };
    const onSearchBlur = debounce(query => {
        setVehicleLedgerData([]);
        setLoadingText("Loading........");
        setCurrentPageNo(defaultPageNo)
        dispatchGetVehicleLedgerAction({ ...vehicleLedgerRequestData, searchText: query },
            () => {
                trackDwebEvent('Dweb Vehicles Page', {})
                logger.log("Trucks Component", "Vehicles Ledger Data Loading Success");
                setLoadingText("Sorry, no Trucks found");
            },
            () => {
                logger.log("Trucks Component", "Vehicles Ledger Data Loading Failure");
                setLoadingText("Sorry, no Trucks found");
            }
        )
    }, user && user.configs && user.configs.dwebSearchBebounceMs ? parseInt(user.configs.dwebSearchBebounceMs) : defaultDebounceMs);
    const getPaginatedData = () => {
        const vehiclePaginatedReqData = {
            fleetOwnerId: user && user.userInfo && user.userInfo.entityId ? user.userInfo.entityId : null,
            ownershipType: ["SELF", "HIRED"],
            vehicleStatus: ["AVAILABLE", "ONTRIP"],
            pageNo: currentPageNo + 1,
            pageSize: currentPageSize,
            searchText: searchText,
            merge: true
        };
        dispatchGetVehicleLedgerAction(vehiclePaginatedReqData,
            () => {
                trackDwebEvent('Dweb Vehicles Page', {})
                logger.log("Trucks Component", "Vehicles Ledger Data Loading Success");
            },
            () => {
                logger.log("Trucks Component", "Vehicles Ledger Data Loading Failure");
            }
        );
    }
    useEffect(() => {
        dispatchGetVehicleLedgerAction(vehicleLedgerRequestData,
            () => {
                trackDwebEvent('Dweb Vehicles Page', {})
                logger.log("Trucks Component", "Vehicles Ledger Data Loading Success");
            },
            () => {
                logger.log("Trucks Component", "Vehicles Ledger Data Loading Failure");
            }
        );
        if (vehicle.singleTruck) {
            vehicle.singleTruck = {}
        }
    }, [
        dispatchGetVehicleLedgerAction
    ]);
    useEffect(() => {
        if (vehicle.vehicleLedgerData && vehicle.vehicleLedgerData) {
            setVehicleLedgerData(vehicle.vehicleLedgerData);
        }
    }, [vehicle.vehicleLedgerData]);

    // const goToTrip = () => {
    //     history.push({
    //         pathname: '/trips/create',
    //         state: {
    //             id: 7,
    //             pageTitle: 'Create Trip'
    //         }
    //     });
    // }

    // const handleAddPartyClick = () => {
    //     setVehicleModalOpen(true);
    // }
    // const handleAddPartyModalClose = (status) => {
    //     setVehicleModalOpen(status);
    // }

    // const handlePartySave = (status) => {
    //     if (status) {
    //         dispatchGetVehicleLedgerAction(vehicleLedgerRequestData, () => {
    //         }, () => {
    //         })
    //     }
    // }

    const handleVehicleRow = (index) => {
        if (index == 0 || index) {
            const vehicleId = vehicleLedgerData[index].id;
            const vehicleNumberPreffix = vehicleLedgerData[index].vehicleNumberPrefix;
            const vehicleNumberSuffix = vehicleLedgerData[index].vehicleNumberSuffix;
            const status = vehicleLedgerData[index].status;
            const ownershipTypeValue = vehicleLedgerData[index].ownershipType;
            const bodyTypeValue = vehicleLedgerData[index].vehicleBodyType;

            history.push({
                pathname: `/trucks/single-truck/${vehicleId}`,
                state: {
                    id: 8,
                    vehicleStatus: status || null,
                    pageTitle: [vehicleNumberPreffix, vehicleNumberSuffix],
                    vehicleId: vehicleId,
                    ownershipType: ownershipTypeValue,
                    bodyType: bodyTypeValue
                }
            });
        }
    }
    const muiData = vehicleLedgerData;
    const muiColumns = [
        {
            name: "vehicleNumber",
            label: "Truck No",
            options: {
                filter: true,
                sort: false,
                customBodyRenderLite: (dataIndex, rowIndex) => {
                    if (rowIndex === muiData.length - 3) {
                        return (
                            <Fragment>
                                <Waypoint
                                    onEnter={() => {
                                        if (vehicle && vehicle.vehiclesMaxPage && vehicle.vehiclesMaxPage != currentPageNo) {
                                            getPaginatedData()
                                            setCurrentPageNo(currentPageNo + 1)
                                        }
                                    }}
                                />
                                <div style={{ display: 'flex', textTransform: 'uppercase' }}>
                                    {vehicleLedgerData && vehicleLedgerData[dataIndex] && vehicleLedgerData[dataIndex].vehicleNumArrayDweb && vehicleLedgerData[dataIndex].vehicleNumArrayDweb.length > 2 && vehicleLedgerData[dataIndex].vehicleNumArrayDweb.map((item) => (
                                        <div className={classes.vehileNumber}>{item}</div>
                                    ))
                                    }
                                </div>
                            </Fragment>
                        );
                    } else {
                        return (
                            <>
                                <div style={{ display: 'flex', textTransform: 'uppercase' }}>
                                    {vehicleLedgerData && vehicleLedgerData[dataIndex] && vehicleLedgerData[dataIndex].vehicleNumArrayDweb && vehicleLedgerData[dataIndex].vehicleNumArrayDweb.length > 2 && vehicleLedgerData[dataIndex].vehicleNumArrayDweb.map((item) => (
                                        <div className={classes.vehileNumber}>{item}</div>
                                    ))
                                    }
                                </div>
                            </>
                        )
                    }
                }
            },
        },
        {
            name: "vehicleBodyType",
            label: "Truck Type",
            options: {
                filter: true,
                sort: false,
                customBodyRender: (value) => {
                    return (
                        <div className={classes.fw300}>{value}</div>
                    )
                }
            },
        },
        {
            name: "ownershipType",
            label: "Ownership",
            options: {
                filter: true,
                sort: false,
                customBodyRender: (value, tableMeta, updateValue) => {
                    return (
                        value === "HIRED"
                            ?
                            <span className={classes.fw300}>Hired</span>
                            :
                            <span className={classes.fw300}>Self</span>
                    )
                }
            },
        },
        {
            name: "status",
            label: "Status",
            options: {
                filter: true,
                sort: false,
                customBodyRender: (value, tableMeta, updateValue) => {
                    return (
                        <div className={classes.statusDiv}> <FiberManualRecordIcon
                            className={value == 'Available' ? classes.circle : classes.circleOnTrip}
                        ></FiberManualRecordIcon><div className={classes.statusV1}>{value}</div></div>
                    )
                }
            },
        },
        {
            name: "vehicleStartLocation",
            label: "Location",
            options: {
                filter: true,
                sort: false,
                customBodyRenderLite: (dataIndex, rowIndex) => {
                    return (
                        vehicleLedgerData[dataIndex].lastLocation
                            ?
                            <span className={classes.fw300}>{vehicleLedgerData[dataIndex].lastLocation}</span>
                            :

                            (
                                (vehicleLedgerData[dataIndex].startLocation && vehicleLedgerData[dataIndex].destinationLocation)
                                    ?
                                    < div className={classes.divLocation} > <div>{vehicleLedgerData[dataIndex].startLocation}</div><ArrowRightAltIcon className={classes.arrowRightV1} /><div>{vehicleLedgerData[dataIndex].destinationLocation}</div></div >
                                    :
                                    <div className={classes.fw300}></div>
                            )
                    )
                }
            },
        },
    ];
    const options = {
        rowsPerPage: 100,
        pagination: false,
        rowsPerPageOptions: [10, 100, 250],
        filterType: "multiselect",
        fixedHeader: true,
        tableBodyHeight: tableHeightWithSparkline,
        selectableRows: 'none',
        searchOpen: true,
        search: false,
        jumpToPage: false,
        download: false,
        filter: false,
        print: false,
        viewColumns: false,
        onRowClick: (rowData, rowMeta) => {
            handleVehicleRow(rowMeta.dataIndex);
        },
        customToolbar: (data) => {
            return <>
                {/* <Button variant="contained" classes={{ root: classes.addPartyCta, label: classes.label, }} color="primary" onClick={handleAddPartyClick}>
                    <AddIcon /> Add Vehicle
                </Button>
                <Button variant="contained" classes={{ root: classes.addTripCta, label: classes.label, }} color="primary" onClick={goToTrip}>
                    <AddIcon /> Add Trip
                </Button> */}
            </>
        },
        customToolbarSelect: (selectedRows, displayData, setSelectedRows) => {

        },
        searchProps: {
            variant: "outlined",
            //value: searchText,
            InputProps: {
                startAdornment: <InputAdornment position="start"><SearchIcon /></InputAdornment>,
            },
            onBlur: (e) => {
            },
            onKeyUp: (e) => {
            },
            onKeyDown: (event) => {
                if (event.keyCode === 27) {
                }
            }
        },
        searchPlaceholder: 'Search Trucks',
        onSearchChange: (val) => {
            let value = val ? !val.replace(/\s/g, '').length ? val.trim() : val : "";
            setSearchText(value);
            if (value && value.length > 1) {
                onSearchBlur(value)
            } else if (searchText && value && value.trim().length <= 1) {
                setSearchText("");
                onSearchBlur("")
            }else{
                setSearchText("");
                onSearchBlur("");
            }
        },
        onKeyUp: (e) => {
        },
        customSearch: (searchQuery, currentRow, columns) => {
            let isFound = false;
            /*if (searchQuery && searchQuery.trim().length > 0) {
                searchQuery = searchQuery.trim()
                currentRow.forEach(col => {
                    if (col && col.toString().toUpperCase().indexOf(searchQuery.toUpperCase()) >= 0) {
                        isFound = true;
                    }
                });
            } else {
                isFound = true;
            }*/
            return true;
        },
        textLabels: {
            body: {
                noMatch: loadingText,
                toolTip: "Sort",
                columnHeaderTooltip: column => `Sort for ${column.label}`
            }
        }
    };

    return (<Wrapper>
        <Paper className={classes.pageContentDIv} elevation={3}>
            <div className={classes.paddingRightV1}>
                <Grid container direction="row">
                    <Grid item>
                        <div className={classes.marginBottomV1}>
                            <TopCard title='All trucks' infoTitle='All trucks' infoText='The number of total trucks added.All Trucks = My Trucks + Market Trucks' color="#0b1323" infoIcon={true} cardValue={vehicle.allTruckCount ? vehicle.allTruckCount : 0} />
                        </div>
                    </Grid>
                    <Grid item>
                        <div className={classes.mlV3}>
                            <TopCard title='My Trucks' infoTitle='My trucks' infoText='The number of own trucks added to your account' color="#6b778c" infoIcon={true} cardValue={vehicle.myTruckCount ? vehicle.myTruckCount : 0} />
                        </div>
                    </Grid>
                    <Grid item>
                        <div className={classes.mlV3}>
                            <TopCard title='Market Trucks' infoTitle='Market Trucks' infoText='The number of market trucks added to your account' color="#f27f36" infoIcon={true} cardValue={vehicle.hiredTruckCount ? vehicle.hiredTruckCount : 0} />
                        </div>
                    </Grid>
                </Grid>
            </div>
            <MUIDataTable title={""} data={muiData} columns={muiColumns} options={options} />
        </Paper>
        {/* {addPartyModalOpen && <AddParty open={addPartyModalOpen} onClose={handleAddPartyModalClose} onSave={handlePartySave} />} */}
    </Wrapper>);
};
const mapStateToProps = (state) => (state);
const mapDispatchToProps = (dispatch) => ({
    dispatchLogoutAction: () => dispatch(logoutUser()),
    dispatchGetVehicleLedgerAction: (requestData, onSuccess, onError) => {
        dispatch(getVehicleLedgerData(requestData, onSuccess, onError))
    },
});
const VehiclesWithRouter = withRouter(Vehicles);
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(VehiclesWithRouter);